import { render, staticRenderFns } from "./zzsy.vue?vue&type=template&id=4e1f1466&scoped=true"
import script from "./zzsy.vue?vue&type=script&lang=js"
export * from "./zzsy.vue?vue&type=script&lang=js"
import style0 from "./zzsy.vue?vue&type=style&index=0&id=4e1f1466&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1f1466",
  null
  
)

export default component.exports